// client/src/components/InputGroup.js
import React from "react";

const InputGroup = ({ label, children, error }) => {
  return (
    <div className="flex flex-col">
      <label className="font-medium text-gray-700 mb-1">{label}</label>
      {children}
      {error && (
        <span className="text-red-500 text-sm mt-1">{error}</span>
      )}
    </div>
  );
};

export default InputGroup;

